import "./postplayingtemplateone.css";
import { React, ReactPlayer } from "../../../Libraries/Post/PostPlaying/index";
import DOMPurify from 'dompurify';

const PostPlayingTemplateOne = (props) => {
  return (
    <div className="playingwrapper">
      {props?.data?.finalfile?.txt_media_file_type === "Image" ? (
        <div className="img-container">
          <img
            src={props.data.finalfile.txt_media_streaming_link}
            alt="img"
            width="100%"
            height="100%"
          />
        </div>
      ) : props?.data?.finalfile?.txt_media_file_type === "Video" ? (
        <div className="video-container">
          <ReactPlayer
            url={props?.data?.finalfile?.txt_media_streaming_link}
            loop={true}
            playing={true}
            playsInline
            height="100%"
            width="100%"
            controls
          />
        </div>
      ) : props?.data?.finalfile?.txt_media_file_type === "Live" ? (
        <div className="video-container">
          <ReactPlayer
            url={props?.data?.finalfile?.txt_media_streaming_link}
            loop={true}
            playing={true}
            playsInline
            height="100%"
            width="100%"
            controls
          />
        </div>
      ) : props?.data?.finalfile?.txt_media_file_type === "Widget" ? (
        <div className="widget-container">
          {/* <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(props?.data?.finalfile?.txt_media_streaming_link),
            }}
            style={{ height: "100%" }}
          /> */}
          <p>{props?.data?.finalfile?.txt_media_streaming_link}</p>
        </div>
      ) : null}
    </div>
  );
};

export default PostPlayingTemplateOne;
